import React from 'react';
import { cn } from '../../utils/cn';

const STATUSES = {
  online:  'bg-success',
  busy:    'bg-warn',
  away:    'bg-mute',
  offline: 'bg-mute-2',
  error:   'bg-danger',
};

const SIZES = {
  xs: 'w-1.5 h-1.5',
  sm: 'w-2   h-2',
  md: 'w-2.5 h-2.5',
  lg: 'w-3   h-3',
};

export function StatusDot({ status = 'online', size = 'md', pulse = false, className, ...rest }) {
  return (
    <span
      role="status"
      aria-label={status}
      className={cn(
        'inline-block rounded-full',
        SIZES[size],
        STATUSES[status],
        pulse && 'animate-pulse',
        className
      )}
      {...rest}
    />
  );
}

export default StatusDot;
